import { render, staticRenderFns } from "./OfficeWrapper.vue?vue&type=template&id=60fea515&"
import script from "./OfficeWrapper.vue?vue&type=script&lang=js&"
export * from "./OfficeWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports